import { useCallback, useEffect, useState } from 'react';

interface VanPaintSVGProps {
  view: 'left' | 'top' | 'right';
  className?: string;
  onLoad?: () => void;
}

/**
 * Komponent SVG vana dla widoku punktów pomiarowych lakieru
 *
 * Dynamicznie importuje odpowiedni plik SVG na podstawie widoku:
 * - left: svg/van-left.svg
 * - top: svg/all-center.svg (wspólny dla wszystkich typów)
 * - right: svg/van-right.svg
 */
export const VanPaintSVG: React.FC<VanPaintSVGProps> = ({
  view,
  className = '',
  onLoad,
}) => {
  const [IconComponent, setIconComponent] = useState<React.FC<React.SVGProps<SVGSVGElement>> | null>(null);

  const getSvgName = useCallback(() => {
    switch (view) {
      case 'left':
        return 'van-left';
      case 'top':
        return 'all-center';
      case 'right':
        return 'van-right';
      default:
        return 'van-left';
    }
  }, [view]);

  const importIcon = useCallback(async () => {
    try {
      const svgName = getSvgName();
      /* @vite-ignore */
      const imported = await import(`./svg/${svgName}.svg`);
      setIconComponent(() => imported.ReactComponent);
    } catch (error) {
      console.error('Błąd ładowania SVG vana:', error);
    }
  }, [getSvgName]);

  useEffect(() => {
    importIcon();
  }, [importIcon]);

  useEffect(() => {
    if (IconComponent) {
      onLoad?.();
    }
  }, [IconComponent, onLoad]);

  if (!IconComponent) {
    return <div className={className} />;
  }

  return <IconComponent className={className} />;
};
